import React from "react";
import classNames from "classnames/bind";
import styles from "../PrimaryCard/PrimaryCard.module.scss";
import SchemaCardProps from "./types";
import LastUpdated from "./LastUpdated";
import { getLastUpdate } from "../../utils/timeFormatter";

const cx = classNames.bind(styles);

// TODO: this component is unnecessary and needs to be binned. It's also horribly built.
/**
 * a card to display schema meta including title, description, author and last updated
 */
const SchemaCard = ({
  id,
  title,
  description,
  category,
  date,
  onClick,
  isLoading = false,
  isSolo = false,
  cardConfig = {
    hasGreyBar: true,
    hasDescriptionLabel: true,
    hasReducedHeight: false,
  },
}: SchemaCardProps) => {
  const lastUpdate = getLastUpdate(date);

  return (
    <>
      {isLoading ? (
        <button
          className={cx("container", "loading", {
            "container-solo": isSolo,
            reducedHeightContainer: cardConfig.hasReducedHeight,
          })}
        >
          <div className={cx("skeletons")}>
            <div
              className={cx("skeleton")}
              style={{ width: 240 }}
            />
            <div>
              <div
                className={cx("skeleton")}
                style={{ width: 240 }}
              />
              <div
                className={cx("skeleton")}
                style={{ width: 240 }}
              />
              <div
                className={cx("skeleton")}
                style={{ width: 240 }}
              />
            </div>
            <div className={cx("skeleton")} />
          </div>
        </button>
      ) : (
        <button
          className={cx("container", {
            "container-solo": isSolo,
            reducedHeightContainer: cardConfig.hasReducedHeight,
          })}
          onClick={() => onClick(id)}
        >
          <div className={cx("titleContainer")}>
            <p className={cx("title")}>{title}</p>
          </div>

          <div className={cx("descriptionContainer")}>
            {category && category !== "" ? (
              <p className={cx("description")}>
                <span className={cx("bold")}>Form Category: </span>
                {category}
              </p>
            ) : null}
            {description && description !== "" ? (
              <p className={cx("description")}>
                {cardConfig.hasDescriptionLabel ? (
                  <span className={cx("bold")}>Description: </span>
                ) : null}
                {description}
              </p>
            ) : null}
          </div>

          <LastUpdated
            lastUpdate={lastUpdate}
            cardConfig={cardConfig}
          />
        </button>
      )}
    </>
  );
};

export default SchemaCard;
